<div class="wrapper" [style.background-color]="this.color">
  <span [style.background-color]="this.accent"></span>
  <span [style.color]="this.accent"><ng-content></ng-content></span>
</div>
